export const ProtocolOrderTypeEnum = {
    'NURSE': 'nurse',
    'TEST': 'test',
    'TREATMENTS': 'treatments',
    'CONSULT': 'consult',
};
//# sourceMappingURL=em-responses.js.map